import { render, staticRenderFns } from "./BalanceSummary.vue?vue&type=template&id=3f5e1e97&scoped=true&lang=pug&"
import script from "./BalanceSummary.vue?vue&type=script&lang=ts&"
export * from "./BalanceSummary.vue?vue&type=script&lang=ts&"
import style0 from "./BalanceSummary.vue?vue&type=style&index=0&id=3f5e1e97&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5e1e97",
  null
  
)

export default component.exports